import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {},
  class: "posRe fl pad10"
}
const _hoisted_2 = { class: "fl llgreyBg pad20 rad20 mr15 mb10" }
const _hoisted_3 = { class: "fw600 fw14 mb19" }
const _hoisted_4 = {
  class: "with_white_bg ddgrey pad20 with_shadow mt20",
  style: {"width":"320px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw600 w100 mt5" }
const _hoisted_7 = { class: "w100 grey" }
const _hoisted_8 = {
  key: 0,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"-6px","right":"6px","background":"#69d54f"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_InputLocationModal = _resolveComponent("InputLocationModal")!
  const _component_ChangeLocationModal = _resolveComponent("ChangeLocationModal")!

  return (_ctx.showLocations)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`message.select_location`)), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loctags, (loctag, loctagindex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${loctagindex}${loctag.id}${_ctx.systemUpdatedAt}`,
              class: _normalizeClass(`fl centered sel${loctag.id} posRe`)
            }, [
              _createVNode(_component_Popper, { hover: true }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: `${_ctx.$getAssetImageUrl(
                                    loctag.public_id != `free`
                                        ? _ctx.Util.getURLFromAddress(loctag.keyword, '80x80', true)
                                        : `/assets/call/call_free.png`
                                )}`,
                      height: "80",
                      width: "80"
                    }, null, 8, _hoisted_5),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(loctag.keyword), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(loctag.address ? loctag.address : _ctx.$t(`location.online`)), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_LocationIcon, {
                    loctag: loctag,
                    canDelete: false,
                    useLocationIcon: true,
                    width: 65,
                    totalHeight: 90,
                    onClickLocation: _ctx.clickLocation
                  }, null, 8, ["loctag", "onClickLocation"])
                ]),
                _: 2
              }, 1024),
              (!_ctx.isPreview && loctag.selected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                      width: "17",
                      height: "17",
                      style: {"margin-top":"-2px"}
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _hoisted_10
        ]),
        _hoisted_11,
        _createVNode(_component_InputLocationModal, {
          appo: _ctx.appo,
          onUpdatedLocation: _ctx.updatedLocation
        }, null, 8, ["appo", "onUpdatedLocation"]),
        _createVNode(_component_ChangeLocationModal, {
          willSelectLoctag: _ctx.willSelectLoctag,
          appo: _ctx.appo,
          onSelect: _ctx.selectLocation
        }, null, 8, ["willSelectLoctag", "appo", "onSelect"])
      ]))
    : _createCommentVNode("", true)
}